var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-tile-macro.j2"] = require( "macros/product-tile-macro.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/sayt-popular.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-tile-macro.j2", false, "core/templates/sayt-popular.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayProductTile")) {
var t_4 = t_1.displayProductTile;
} else {
cb(new Error("cannot import 'displayProductTile'")); return;
}
context.setVariable("displayProductTile", t_4);
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "havePopularData")) {
output += "\n\n    ";
var t_5;
t_5 = (lineno = 4, colno = 47, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.enhancedSayt.display_product_results_right",runtime.contextOrFrameLookup(context, frame, "False")]));
frame.set("displayProductResultsToTheRight", t_5, true);
if(frame.topLevel) {
context.setVariable("displayProductResultsToTheRight", t_5);
}
if(frame.topLevel) {
context.addExport("displayProductResultsToTheRight", t_5);
}
output += "\n    ";
var t_6;
t_6 = env.getFilter("length").call(context, (lineno = 5, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.sayt.header.popularProducts",[]]))) > 0;
frame.set("showProductResults", t_6, true);
if(frame.topLevel) {
context.setVariable("showProductResults", t_6);
}
if(frame.topLevel) {
context.addExport("showProductResults", t_6);
}
output += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "showProductResults")) {
output += "\n        ";
var t_7;
t_7 = "sayt_product_results";
frame.set("titleLocalizationKey", t_7, true);
if(frame.topLevel) {
context.setVariable("titleLocalizationKey", t_7);
}
if(frame.topLevel) {
context.addExport("titleLocalizationKey", t_7);
}
output += "\n    ";
;
}
else {
output += "\n        ";
var t_8;
t_8 = "sayt_popular_heading";
frame.set("titleLocalizationKey", t_8, true);
if(frame.topLevel) {
context.setVariable("titleLocalizationKey", t_8);
}
if(frame.topLevel) {
context.addExport("titleLocalizationKey", t_8);
}
output += "\n    ";
;
}
output += "\n\n    <div class=\"c-sayt-popular s-sayt-popular ";
if(runtime.contextOrFrameLookup(context, frame, "showProductResults")) {
output += "showing-product-results";
;
}
output += " ";
if(runtime.contextOrFrameLookup(context, frame, "displayProductResultsToTheRight")) {
output += "c-sayt-popular--show-right";
;
}
output += "\" data-qa-sayt-popular>\n\n        <h3 class=\"c-sayt-popular__h3\">\n            ";
if(runtime.contextOrFrameLookup(context, frame, "showProductResults")) {
output += "\n                ";
output += runtime.suppressValue((lineno = 17, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.contextOrFrameLookup(context, frame, "titleLocalizationKey")])) + "" + ": ", env.opts.autoescape);
output += " <span class='c-sayt-popular__h3--search-term'> ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "productResultsSearchTerm"), env.opts.autoescape);
output += " </span>\n            ";
;
}
else {
output += "\n                ";
var t_9;
t_9 = (lineno = 19, colno = 52, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.featureConfigs.headerFeatureConfig.saytPopularOverrideTitle",""]));
frame.set("saytPopularOverrideTitle", t_9, true);
if(frame.topLevel) {
context.setVariable("saytPopularOverrideTitle", t_9);
}
if(frame.topLevel) {
context.addExport("saytPopularOverrideTitle", t_9);
}
output += "\n                ";
var t_10;
t_10 = (runtime.contextOrFrameLookup(context, frame, "saytPopularOverrideTitle")?runtime.contextOrFrameLookup(context, frame, "saytPopularOverrideTitle"):(lineno = 20, colno = 104, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.sayt.header.popularDisplayName",""])));
frame.set("popularDisplayName", t_10, true);
if(frame.topLevel) {
context.setVariable("popularDisplayName", t_10);
}
if(frame.topLevel) {
context.addExport("popularDisplayName", t_10);
}
output += "\n                ";
var t_11;
t_11 = (lineno = 21, colno = 52, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.featureConfigs.headerFeatureConfig.saytPopularOverride",""]));
frame.set("specifiedPopularCategory", t_11, true);
if(frame.topLevel) {
context.setVariable("specifiedPopularCategory", t_11);
}
if(frame.topLevel) {
context.addExport("specifiedPopularCategory", t_11);
}
output += "\n                ";
var t_12;
t_12 = (env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "specifiedPopularCategory")) > 0) && (env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "popularDisplayName")) > 0);
frame.set("havePopularHeaderOverride", t_12, true);
if(frame.topLevel) {
context.setVariable("havePopularHeaderOverride", t_12);
}
if(frame.topLevel) {
context.addExport("havePopularHeaderOverride", t_12);
}
output += "\n                ";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "havePopularHeaderOverride")?runtime.contextOrFrameLookup(context, frame, "popularDisplayName"):(lineno = 23, colno = 71, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.contextOrFrameLookup(context, frame, "titleLocalizationKey")]))), env.opts.autoescape);
output += "\n            ";
;
}
output += "\n        </h3>\n\n        <div class=\"c-sayt-popular__products\">\n\n            ";
frame = frame.push();
var t_15 = runtime.contextOrFrameLookup(context, frame, "popularData");
if(t_15) {var t_14 = t_15.length;
for(var t_13=0; t_13 < t_15.length; t_13++) {
var t_16 = t_15[t_13];
frame.set("product", t_16);
frame.set("loop.index", t_13 + 1);
frame.set("loop.index0", t_13);
frame.set("loop.revindex", t_14 - t_13);
frame.set("loop.revindex0", t_14 - t_13 - 1);
frame.set("loop.first", t_13 === 0);
frame.set("loop.last", t_13 === t_14 - 1);
frame.set("loop.length", t_14);
output += "\n\n                ";
output += runtime.suppressValue((lineno = 31, colno = 35, runtime.callWrap(t_4, "displayProductTile", context, [t_16,runtime.makeKeywordArgs({"tileTemplate": "TITLE_ONLY","displayOverlayControls": runtime.contextOrFrameLookup(context, frame, "False"),"attributes": runtime.memberLookup((t_16),"gaAttributes")})])), env.opts.autoescape);
output += "\n\n            ";
;
}
}
frame = frame.pop();
output += "\n\n        </div>\n\n    </div>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/sayt-popular.j2"] , dependencies)